export const LAST_SELECTED_MARKET_COOKIE = "last-market";

export type LastSelectedMarket = string;

export const DEFAULT_LAST_SELECTED_MARKET: LastSelectedMarket = "";

export function isValidLastSelectedMarket(value: unknown): value is LastSelectedMarket {
  return typeof value === "string";
}
